import React, { useState } from 'react'
import { connect } from 'react-redux'
import { actions as unitTestsActions } from '../../../../../../../store/reducers/unit-tests.reducer'
import TestModal from '../TestModal'

const CreateFunctionInTestModal = ({
    showCreateFunctionInTestModal,
    setShowCreateFunctionInTestModal,
    createFunctionInTest,
}) => {
    const [errorMessage, setErrorMessage] = useState('')

    const handleSubmitTest = (token, fields) => {
        setErrorMessage('')
        return createFunctionInTest(token, fields, setErrorMessage)
    }

    return (
        <TestModal
            showModal={showCreateFunctionInTestModal}
            setShowModal={setShowCreateFunctionInTestModal}
            submitTest={handleSubmitTest}
            modalTitle='Create Function in Test'
            submitButtonText='Create'
            fields={{
                name: true,
                input: true,
                functionName: true,
                cpuTimeLimit: true,
                memoryLimit: true,
                exactMatch: true,
                ignoreCase: true,
                fixtureFiles: true,
            }}
            errorMessage={errorMessage}
        />
    )
}

const mapState = ({ unitTests }) => {
    return {
        showCreateFunctionInTestModal: unitTests.showCreateFunctionInTestModal,
    }
}

const mapDispatch = dispatch => {
    return {
        setShowCreateFunctionInTestModal: value => {
            dispatch(unitTestsActions.setShowCreateFunctionInTestModal(value))
        },
        createFunctionInTest: (token, fields, setResponseMessage) => {
            return dispatch(unitTestsActions.createFunctionInTest(token, fields, setResponseMessage))
        },
    }
}

export default connect(mapState, mapDispatch)(CreateFunctionInTestModal)
